import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { Capacitor } from '@capacitor/core';
import PropTypes from 'prop-types';

// Create a Context
const IsMobileContext = createContext();

// Create a Provider component
export const MobileContextProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [mobileMode, setMobileMode] = useState('md');
  const [activeComponent, setActiveComponent] = useState(null);
  useEffect(() => {
    const platform = Capacitor.getPlatform();
    if (platform === 'android' || platform === 'ios') {
      setIsMobile(true);
      setMobileMode(platform === 'ios' ? 'ios' : 'md');
    } else {
      setIsMobile(false);
    }
  }, []);

  const contextValue = useMemo(
    () => ({
      isMobile,
      mobileMode,
      activeComponent,
      setActiveComponent,
    }),
    [isMobile, mobileMode, activeComponent, setActiveComponent],
  );

  return (
    <IsMobileContext.Provider value={contextValue}>
      {children}
    </IsMobileContext.Provider>
  );
};

MobileContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Create a custom hook to use the context
export const useMobileSettings = () => {
  return useContext(IsMobileContext);
};
